<div class="keen-slider" style="height: 390px;" #sliderRef>
    <ng-container *ngIf="isServer; else lazyBrowserTpl">
      <div class="keen-slider__slide">
        <img
          class="keen-slider__image"
          src="https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=420"
          srcset="https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=420 420w,
            https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=700 700w,
            https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=960 960w"
          sizes="(max-width: 420px) 420px, (max-width: 700px) 700px, 960px"
          fetchPriority="high"
          loading="eager"
          alt="">
      </div>
    </ng-container>
    <ng-template #lazyBrowserTpl>
      <div class="keen-slider__slide" *ngFor="let image of hostel?.propertyImages; let i = index;">
        <img
          ngOptimizedImage
          class="keen-slider__image"
          [ngSrc]="image.fileName"
          [fill]="true"
          [priority]="i === 0 ? true : false"
          ngSrcset="420w, 700w, 960w"
          sizes="(max-width: 420px) 420px, (max-width: 700px) 700px, 960px"
          alt="">
      </div>
    </ng-template>
</div>
